module.exports = __webpack_public_path__ + "img/51626528_L.2222b3c7.png";